import React, { useState } from 'react';
import Panel from '../../../../components/Panel';
import JobTaskPanelHeader from '../JobTaskPanelHeader/JobTaskPanelHeader';
import JobTaskPanelContent from '../JobTaskPanelContent/JobTaskPanelContent';

const JobTaskPanel = ({ milestone, bucketStatus, onClose }) => {
    // when a modal is opened above the panel, this state is used to control the closing of the panel
    const [shouldClosePanelOnOutsideClick, setShouldClosePanelOnOutsideClick] = useState(true);

    return (
        <Panel
            onClose={onClose}
            showControls={false}
            closeByClickOutside={shouldClosePanelOnOutsideClick}
        >
            <JobTaskPanelHeader
                milestone={milestone}
                bucketStatus={bucketStatus}
                onClose={onClose}
            />
            {!!milestone.content?.length && (
                <JobTaskPanelContent
                    contentArray={milestone.content}
                    setShouldClosePanelOnOutsideClick={setShouldClosePanelOnOutsideClick}
                />
            )}
        </Panel>
    );
};

export default JobTaskPanel;
